import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../common-components/button/Button.jsx";
import InputField from "../../common-components/input-field/Input-field.jsx";
import Select from "../../common-components/select/Select.jsx";
import { setCurrentStep, setSelectedTargetOption, updateSelectedTargetOption, setTargetPayload } from "../../state/reducers/databaseConversion.js";
import { dbOptions } from "./database-conversion-options";


function TargetOptionsDB() {
  const [targetDB, setTargetDB] = useState();
  const [errors, setErrors] = useState();
  const selectedTargetOption = useSelector((state) => state.databaseConversion.selectedTargetOption);
  const dispatch = useDispatch();
  const sourceList = dbOptions.map(option => {
    return {
      label: option.dbName,
      value: option.dbName
    }
  });

  
  
  const handleTargetValueChange = (target, name, type) => {
    let value = target.value;
    if (name === "port") {
      value = parseInt(value, 10);
    }
    if (type === "file") {
      dispatch(updateSelectedTargetOption({
        value,
        file: target.files[0],
        name: name
      }));
    } else {
      dispatch(updateSelectedTargetOption({
        value,
        name: name
      }));
    }
  };

  useEffect(() => {
    console.log("Target DB", targetDB)
    if(targetDB){
      const options = dbOptions.find(option => option.dbName === targetDB).options;
      const targetOption = options.map(option => {
        option.value = undefined;
        return option;
      })
      dispatch(setSelectedTargetOption(targetOption))
    }
  }, [targetDB])

  const handleNextClick = async () => {
    let fieldErrors = {};
    if (!selectedTargetOption || !targetDB) {
      fieldErrors.targetDB = "Select Target Option";
      return;
    }
    selectedTargetOption.map(option => {
      console.log("Options: ", option)
      if(option.validations.required && !option.value){
        console.log("Condition Satisfied")
        fieldErrors[option.inputName] = option.labelName + " is required"
      } else {
        fieldErrors[option.inputName] = undefined
      }
    })
    console.log("Field Errors: ", fieldErrors)
    setErrors({
      ...errors,
      ...fieldErrors
    })
    console.log("Errors: ", errors);
    let errorFlag = false;
    // Loop through the object keys
    for (let key in fieldErrors) {
      // Check if the value of the key is not undefined
      if (fieldErrors[key] !== undefined) {
        errorFlag = true;  // If any value is not undefined, return false
      }
    }

    if(errorFlag){
      return;
    }
    
    const properties = selectedTargetOption.reduce((acc, option) => {
      acc[option.inputName] = option.value;
      return acc;
    }, {});


    console.log("Tproperties", properties)

    const payload = {
      name: targetDB,
      properties
    };
    console.log("Tpayload", payload)

    dispatch(setTargetPayload({
      [`${targetDB.toLowerCase()}_details`]: payload
    }));
    dispatch(setCurrentStep(3));
  };
  console.log("Selected target: ", selectedTargetOption, errors)
  return (
    <div className="page-wrapper database-conversion-page px-3">
      <Container>
        <Row>
          <Col>
            <h2 className="page-title">Connect to Target Database</h2>
            <div className="database-conversation-wrapper">
              <Row className="mb-5">
                <Col md={10}>
                  <div className="source-wrapper">
                    <Row> 
                      <Col>
                        <Select value={targetDB} 
                          onChange={(e) => {
                            if(e.target.value){
                              setErrors({
                                ...errors,
                                targetDB: undefined
                              })
                            }
                            setTargetDB(e.target.value)
                          }} 
                          label="Target Database" 
                          options={sourceList}
                          layoutStyle="horizontal"
                          labelColSize={4}
                          inputColSize={8}
                          required
                          validationMsg={errors?.targetDB}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        {selectedTargetOption?.map((source) => (
                          <InputField 
                            key={source.inputName} 
                            type={source.inputName === "port" ? "number" : source.inputType} 
                            label={source.labelName} 
                            value={source.value} 
                            id={source.inputName} 
                            onChange={(e) => handleTargetValueChange(e.target, source.inputName, source.inputType)}
                            layoutStyle="horizontal"
                            labelColSize={4}
                            inputColSize={8}
                            required={source.validations.required}
                            validationMsg={source.validations.required ? errors?.[source.inputName] : undefined}
                          />
                        ))}
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <CustomButton className="next-btn" label="Back" onClick={() => dispatch(setCurrentStep(1))} />
                </Col>
                <Col className="text-end">
                  {/* <CustomButton className="next-btn" label="Next" onClick={() => dispatch(setCurrentStep(3))} /> */}
                  <CustomButton className="next-btn" label="Next" onClick={handleNextClick} />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default TargetOptionsDB;
  